import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; // Added CommonModule
import { FormsModule } from '@angular/forms';
import { DatePickerModule } from '@syncfusion/ej2-angular-calendars';

import { SigninComponent } from './signin/signin.component';
import { SignupComponent } from './signup/signup.component';

import { AuthRoutingModule } from './auth-routing.module';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { NgxMaskModule } from 'ngx-mask';
import { PasswordStrengthMeterModule } from 'angular-password-strength-meter';
import { DEFAULT_PSM_OPTIONS } from 'angular-password-strength-meter/zxcvbn';

import { SharedModule } from '../shared/shared.module';
import { EditUserComponent } from './edit-user/edit-user.component';
import { PrivacyAndPolicyComponent } from './privacy-and-policy/privacy-and-policy.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { DeleteAccountComponent } from './delete-account/delete-account.component';
import { UnsubscribeComponent } from './unsubscribe/unsubscribe.component';
import { ChildSafetyPolicyComponent } from './child-safety-policy/child-safety-policy.component';
import { IdentityVerificationHandoffComponent } from './identity-verification-handoff/identity-verification-handoff.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { TroubleSignupComponent } from './trouble-signup/trouble-signup.component';
import { CookiePolicyComponent } from './cookie-policy/cookie-policy.component';

import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgOtpInputModule } from 'ng-otp-input';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { environment } from '../../environments/environment';

@NgModule({
  declarations: [
    SigninComponent,
    SignupComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    EditUserComponent,
    PrivacyAndPolicyComponent,
    TermsAndConditionsComponent,
    DeleteAccountComponent,
    UnsubscribeComponent,
    ChildSafetyPolicyComponent,
    IdentityVerificationHandoffComponent,
    AboutUsComponent,
    TroubleSignupComponent,
    CookiePolicyComponent,
  ],
  imports: [
    CommonModule, // Added CommonModule
    BsDatepickerModule, // moved forRoot() to AppModule
    NgOtpInputModule,
    AuthRoutingModule,
    FormsModule,
    DatePickerModule,
    NgxMaskModule,
    PasswordStrengthMeterModule.forRoot(DEFAULT_PSM_OPTIONS),
    SharedModule,
    RecaptchaV3Module,
  ],
  providers: [
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptchaSiteKey },
  ],
})
export class AuthModule {}
